import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CartIcon, MenuIcon, SearchIcon, XIcon } from './icons';
import { useCarrito } from '../../hooks/useCarrito';

const ENLACES = [
  { to: '/catalogo', label: 'Catálogo' },
  { to: '/sobre-nosotros', label: 'Sobre Nosotros' },
  { to: '/contacto', label: 'Contacto' },
];

export function PublicHeader() {
  const { data: carrito } = useCarrito();
  const cantidad = carrito?.lineas.length ?? 0;
  const [menuAbierto, setMenuAbierto] = useState(false);

  return (
    <header className="border-b border-border bg-surface">
      <div className="flex items-center justify-between px-4 sm:px-6 md:px-14 py-4 md:py-5 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-6 md:gap-11">
          <Link to="/" className="font-display text-2xl md:text-3xl font-bold text-wood">
            Santtesanía
          </Link>
          <nav className="hidden md:flex gap-8 text-[15px] font-medium">
            {ENLACES.map((enlace) => (
              <Link key={enlace.to} to={enlace.to} className="text-ink hover:text-terracotta">
                {enlace.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-4 md:gap-5">
          <SearchIcon className="text-ink hidden sm:block" />
          <Link to="/carrito" className="relative" data-testid="header-cart-link">
            <CartIcon className="text-ink" />
            {cantidad > 0 && (
              <span className="absolute -top-2 -right-2 bg-terracotta text-white text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center">
                {cantidad}
              </span>
            )}
          </Link>
          <button
            type="button"
            onClick={() => setMenuAbierto((v) => !v)}
            className="text-ink md:hidden"
            aria-label={menuAbierto ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuAbierto}
          >
            {menuAbierto ? <XIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {menuAbierto && (
        <nav className="md:hidden flex flex-col gap-1 px-4 pb-4 text-[15px] font-medium border-t border-border">
          {ENLACES.map((enlace) => (
            <Link
              key={enlace.to}
              to={enlace.to}
              onClick={() => setMenuAbierto(false)}
              className="text-ink hover:text-terracotta py-2.5"
            >
              {enlace.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
